module.exports = __webpack_public_path__ + "static/48import-b8330edb67915944840c3bfd2a0d4ac5.png";